export default "__VITE_ASSET__fbe73453__"